<template>
  <div>
    <tableComponent
      :url="PBI_ENDPOINTS.base"
      :headings="headings"
      :columns="tableColumns"
      selection-column="name"
      :filterExcludeColumns="['actions']"
      :should-allow-row-selection="true"
      ref="table"
      @row-selected="selectFiles"
      enableSelectAllRowsOnServerTable
      :on-result="setFilters"
    >
      <template #row-selection-button>
        <div class="d-flex flex-row gap-2">
          <div v-if="multiSelected" class="d-flex align-items-center justify-content-start gap-2">
            <CButton
                size="sm"
                color="danger"
                @click="activeDelete = selectedFiles"
            >
              Delete selection
              <i class="fa fa-trash"/>
            </CButton>
          </div>
          <span v-else/>
        </div>
      </template>
      <template #actions="{ row }">
        <CButton color="primary" @click="download(row)" size="sm">
          Télécharger
        </CButton>
        <CButton
          class="action-button ml-2"
          color="danger"
          size="sm"
          @click="handleDelete(row)"
        >
          <em class="fa fa-close" />
          Supprimer
        </CButton>
      </template>
    </tableComponent>
    <CModal
        v-if="activeDelete"
        :show.sync="activeDelete.length"
        centered
        :draggable="false"
    >
      <template slot="header-wrapper">
        <div/>
      </template>
      Etes vous sûr de vouloir supprimer {{ selectedCount }} fichiers?
      <template slot="footer">
        <CButton color="secondary" class="mr-2" @click="activeDelete = null">
          Non
        </CButton>
        <CButton
            color="danger"
            @click="handleDeleteManyFiles"
            data-cy="confirm-delete-button"
        >
          Oui
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { PBI_ENDPOINTS, PbiService } from "@/services/pbi";
import { AlumniService } from "@/services/alumni";

export default {
  name: "PBIFiles",
  data() {
    return {
      PBI_ENDPOINTS,
      headings: {
        name: "Exports",
        creation_date: "Date de création",
        line_count: "Nombre de lignes",
      },
      shouldSelectAllRows: false,
      activeDelete: null,
      selectedFiles: [],
      totalCount: 0,
    };
  },
  computed: {
    tableColumns() {
      return [...Object.keys(this.headings), "actions"];
    },
    selectedCount() {
      return this.shouldSelectAllRows ? this.totalCount : this.selectedFiles.length || 1;
    },
    multiSelected() {
      return !!this.selectedFiles.length
    },
  },
  methods: {
    download(row) {
      AlumniService.downloadFiche6(row.name);
    },
    async handleDelete(row, showAlert=true) {
      if (showAlert && !(await confirm(`Are you sure you want to remove ${ row.name }?`))) {
        return;
      }
      await PbiService.removePbi(row._id);
      this.$refs.table.$refs.table.getData();
    },
    selectFiles(rows, shouldSelectAllRows) {
      console.log(rows)
      this.shouldSelectAllRows = shouldSelectAllRows;
      this.selectedFiles = rows.map(row => row._id)
    },
    async handleDeleteManyFiles() {
      for (const file of this.activeDelete) {
        await this.handleDelete({_id: file}, false)
      }
      this.activeDelete = null
    },
    setFilters(filteredResults, __, totalCount) {
      this.totalCount = totalCount;
    },
  },
};
</script>
